import { computed, ref } from 'vue-demi';
import { useMall } from './use-mall';
import { shuffle } from '../utils';

const isAutoSwitchNavTab = ref(false);
const AUTO_SWITCH_DELAY = 5000; // 自动切换分类间隔时间
let timeouter = 0;

/**
 *  导航分类相关处理
 * @param handelAutoSwitch  自动切换分类处理回调
 * @returns
 */
export function useNavTab(handelAutoSwitch: (id: string) => void) {
  const { mallThemeInfos, isUserClicked, currMallInfo } = useMall();

  /** 商圈分类信息 */
  const mallTabList = computed(() => shuffle(mallThemeInfos.value.map((item) => {
    const { id, name, logo } = item.mallInfo;
    return { id, name, logo };
  })));

  /** 获取下一个待切换的分类ID */
  const nextSwitchId = computed(() => {
    const currId = currMallInfo.value?.id;
    if (!currId) return '';
    const tabList = mallTabList.value;
    const currIndex = tabList.findIndex(item => item.id === currId);
    const nextIndex = tabList[currIndex + 1] ? currIndex + 1 : 0;
    return tabList[nextIndex].id;
  });

  /** 设置自动切换分类 */
  function setAutoSwitchNavTab() {
    isAutoSwitchNavTab.value = true;
  }

  function clearAutoSwitch() {
    clearTimeout(timeouter);
  }

  function startAutoSwitch() {
    if (!isAutoSwitchNavTab.value) return;
    clearAutoSwitch();
    timeouter = window.setTimeout(() => {
      // 用户没有点击商圈任何信息才让自动切换
      if (!isUserClicked.value && nextSwitchId.value) {
        handelAutoSwitch(nextSwitchId.value);
      }
    }, AUTO_SWITCH_DELAY);
  }

  return {
    mallTabList,
    clearAutoSwitch,
    startAutoSwitch,
    setAutoSwitchNavTab,
  };
}
